import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ImpersonationService } from '../services/impersonation.service';

export const actingClientGuard: CanActivateFn = () => {
  const impersonation = inject(ImpersonationService);
  const router = inject(Router);

  if (!impersonation.actingClient()) {
    return router.createUrlTree(['/clients']);
  }

  return true;
};
